export const getListType = (state, listEnvironmentNode) => {
    const beginEnvNameNode = listEnvironmentNode
        .getChild("BeginEnv")
        ?.getChild("EnvNameGroup")
        ?.getChild("ListEnvName");

    const endEnvNameNode = listEnvironmentNode.getChild("EndEnv")?.getChild("EnvNameGroup")?.getChild("ListEnvName");

    if (beginEnvNameNode && endEnvNameNode) {
        return state.sliceDoc(beginEnvNameNode.from, beginEnvNameNode.to).trim();
    }

    return undefined;
};
